module.exports = __webpack_public_path__ + "static/media/icon_3.e16b10b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/icon_3.svg
// module id = 537
// module chunks = 0